import request from "root/js/request";

export const getPredictGMDynamic = async ({
  cabinet_id,
  date_from,
  date_to,
  period,
  in_product_id,
  in_product_id__in,
  source,
  source__in,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/gross_margin_dynamic/",
    method: "get",
    params: {
      cabinet_id,
      date_from,
      date_to,
      period,
      in_product_id,
      in_product_id__in,
      source,
      source__in,
      ...rest,
    },
  });
  return response.data;
};
